import Navbar from "@/pages/home/components/Navbar";
import Footer from "@/pages/home/components/Footer";
import { Link } from "react-router-dom";

const About = () => {
  return (
    <div className="min-h-screen bg-[#faf7f2]" dir="rtl">
      <Navbar />

      {/* Hero */}
      <section className="relative pt-24 pb-0 overflow-hidden">
        <div className="relative h-[420px] md:h-[520px] w-full">
          <img
            src="https://static.readdy.ai/image/b0584b9f674fda78ac14eb56b21cd57d/bc41aac183207ca4c002cb170da5b1e2.jpeg"
            alt="ליאור ועגלת הבשרים"
            className="w-full h-full object-cover object-center"
          />
          <div className="absolute inset-0 bg-gradient-to-l from-black/70 via-black/40 to-transparent"></div>
          <div className="absolute inset-0 flex items-center">
            <div className="max-w-7xl mx-auto px-6 w-full">
              <div className="max-w-xl">
                <span
                  className="inline-block bg-[#e85d04]/20 text-[#f4a261] border border-[#e85d04]/30 px-4 py-1.5 rounded-full text-sm font-semibold mb-4"
                  style={{ fontFamily: "'Assistant', sans-serif" }}
                >
                  הסיפור שלנו
                </span>
                <h1
                  className="text-white font-black text-4xl md:text-6xl leading-tight mb-4"
                  style={{ fontFamily: "'Assistant', sans-serif" }}
                >
                  מאהבה לבשר
                  <br />
                  <span className="text-[#e85d04]">לעגלה על גלגלים</span>
                </h1>
                <p
                  className="text-white/80 text-lg"
                  style={{ fontFamily: "'Assistant', sans-serif" }}
                >
                  הסיפור של ליאור לז'רוביץ ועגלת הבשרים שמביאה את החוויה לכל מקום
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Story Section */}
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-6">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-14 items-center">
            <div>
              <span
                className="inline-block bg-[#e85d04]/10 text-[#e85d04] px-4 py-1.5 rounded-full text-sm font-semibold mb-6"
                style={{ fontFamily: "'Assistant', sans-serif" }}
              >
                הסיפור של ליאור לז'רוביץ
              </span>
              <h2
                className="text-[#1a0a00] font-black text-3xl md:text-4xl mb-6 leading-tight"
                style={{ fontFamily: "'Assistant', sans-serif" }}
              >
                תשוקה בוערת
                <br />
                לעולם הבשר
              </h2>
              <div
                className="text-[#5a3e2b] text-base leading-relaxed space-y-4"
                style={{ fontFamily: "'Assistant', sans-serif" }}
              >
                <p>
                  Meet n&apos; Meat - בשרים עשירים בטעמים אותנטיים וחווית עישון ייחודית! אצלנו הכל עשוי בעבודת יד על גריל עצים אמיתי, בתהליך עישון ממושך שנותן לבשר את הטעמים והארומה הבלתי נשכחים.
                </p>
                <p>
                  ליאור מתמחה בעישון בשרים ארוך ואיטי - בריסקט, אסאדו, ספריבס טלה, ארעייס, צ'וריסו ועוד - כולם מוגשים לצד רטבים ביתיים טעימים לשילוב מנצח. 
אנחנו מאמינים שלא רק הבשר יכול להיות מושלם, גם החוויה שלכם!
                </p>
                <p>
                  במיט אנד מיט אנחנו לא מתמקדים רק בבשר אלא להביא לכם חווית אוכל שתשאיר לכם חיוך על הפנים. ביס שישאיר תמיד טעם של עוד.
                </p>
              </div>
            </div>
            <div className="relative">
              <img
                src="https://static.readdy.ai/image/b0584b9f674fda78ac14eb56b21cd57d/49771f2f9e7923d74fbd67697fffdeef.jpeg"
                alt="חיתוך בשר"
                className="w-full h-80 md:h-96 object-cover object-center rounded-2xl"
              />
              <div className="absolute -bottom-5 -right-5 bg-[#e85d04] text-white rounded-2xl p-5 hidden md:block">
                <div
                  className="text-3xl font-black"
                  style={{ fontFamily: "'Assistant', sans-serif" }}
                >
                  500+
                </div>
                <div
                  className="text-sm font-medium opacity-90"
                  style={{ fontFamily: "'Assistant', sans-serif" }}
                >
                  אירועים מוצלחים
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Vision Section */}
      <section className="py-20 bg-[#faf7f2]">
        <div className="max-w-7xl mx-auto px-6">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-14 items-center">
            <div className="order-2 lg:order-1 relative">
              <img
                src="https://static.readdy.ai/image/b0584b9f674fda78ac14eb56b21cd57d/e041789abd4c1aa05487559eaae96c29.jpeg"
                alt="עגלת הבשרים באירוע"
                className="w-full h-80 md:h-96 object-cover object-center rounded-2xl"
              />
            </div>
            <div className="order-1 lg:order-2">
              <span
                className="inline-block bg-[#e85d04]/10 text-[#e85d04] px-4 py-1.5 rounded-full text-sm font-semibold mb-6"
                style={{ fontFamily: "'Assistant', sans-serif" }}
              >
                חזון העסק
              </span>
              <h2
                className="text-[#1a0a00] font-black text-3xl md:text-4xl mb-6 leading-tight"
                style={{ fontFamily: "'Assistant', sans-serif" }}
              >
                לשבור את קירות
                <br />
                <span className="text-[#e85d04]">המסעדה המסורתית</span>
              </h2>
              <div
                className="text-[#5a3e2b] text-base leading-relaxed space-y-4"
                style={{ fontFamily: "'Assistant', sans-serif" }}
              >
                <p>
                  החזון שעומד מאחורי הקמת עגלת הבשרים הניידת הוא ברור וחדשני: לשבור את קירות מסעדת הבשרים המסורתית ולהביא את חוויית הקולינריה הגבוהה ביותר ישירות אל הלקוח, בכל מקום בו יבחר לחגוג. המטרה היא לאפשר לכל חוגג ליהנות מארוחת בשרים מקצועית ועשירה בטבע הפתוח, בחצר הבית, או באירוע חברה.
                </p>
                <p>
                  הפוד טראק תוכנן ונבנה במיוחד כדי לשמש כמטבח קצה נייד ועוצמתי, המצויד במעשנות מתקדמות ובעמדות גריל רחבות. ליאור שואף להעניק לאורחים חוויה שלמה המפעילה את כל החושים, הכוללת את ריחות הבשר המעושן, קולות הצלייה על הגריל, וחיתוך בשר פרונטלי מול עיני האורחים.
                </p>
                <p>
                  כך הופך כל אירוע לפסטיבל בשרים אותנטי, ללא מגבלות של מקום ומרחב.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Quality Section */}
      <section className="py-20 bg-[#1a0a00]">
        <div className="max-w-7xl mx-auto px-6">
          <div className="text-center mb-14">
            <span
              className="inline-block bg-[#e85d04]/20 text-[#f4a261] px-4 py-1.5 rounded-full text-sm font-semibold mb-4"
              style={{ fontFamily: "'Assistant', sans-serif" }}
            >
              התחייבות לאיכות
            </span>
            <h2
              className="text-white font-black text-4xl md:text-5xl mb-6"
              style={{ fontFamily: "'Assistant', sans-serif" }}
            >
              איכות ללא פשרות
              <br />
              <span className="text-[#e85d04]">בכל נתח</span>
            </h2>
            <p
              className="text-white/70 text-lg max-w-3xl mx-auto leading-relaxed"
              style={{ fontFamily: "'Assistant', sans-serif" }}
            >
              הבסיס לכל מנה שיוצאת מעגלת הבשרים של ליאור הוא איכות ללא פשרות. ההתחייבות הזו מתחילה בבחירה קפדנית של נתחי הפרימיום הטובים ביותר הקיימים בשוק. כל נתח, בין אם הוא מיועד לשעות ארוכות במעשנה או לצלייה מהירה על אש חיה, נבחר בקפידה תוך בחינת רמת השיוש, תהליכי היישון ומקור הבשר.
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-10">
            {[
              {
                icon: "ri-leaf-fill",
                title: "חומרי גלם פרימיום",
                desc: "כל נתח נבחר בקפידה תוך בחינת רמת השיוש, תהליכי היישון ומקור הבשר. אין עיגולי פינות ואין קיצורי דרך.",
              },
              {
                icon: "ri-time-fill",
                title: "תהליכי הכנה מסורתיים",
                desc: "שלבי עבודה מסורתיים החל מרקיחת תערובות תבלינים ייחודיות ועד להשריות ארוכות ומבוקרות. כל פרט מנוהל בקפדנות עליונה.",
              },
              {
                icon: "ri-heart-fill",
                title: "טריות בכל הגשה",
                desc: "כל חומרי הגלם המלווים את הבשר, לרבות הירקות, התוספות והרטבים, הם טריים ומוכנים סמוך ככל האפשר לזמן ההגשה.",
              },
            ].map((item) => (
              <div
                key={item.title}
                className="bg-white/5 border border-white/10 rounded-2xl p-7"
              >
                <div className="w-12 h-12 flex items-center justify-center bg-[#e85d04]/20 rounded-xl mb-5">
                  <i className={`${item.icon} text-[#e85d04] text-2xl`}></i>
                </div>
                <h3
                  className="text-white font-bold text-xl mb-3"
                  style={{ fontFamily: "'Assistant', sans-serif" }}
                >
                  {item.title}
                </h3>
                <p
                  className="text-white/60 text-sm leading-relaxed"
                  style={{ fontFamily: "'Assistant', sans-serif" }}
                >
                  {item.desc}
                </p>
              </div>
            ))}
          </div>

          <p
            className="text-white/50 text-sm text-center max-w-3xl mx-auto leading-relaxed"
            style={{ fontFamily: "'Assistant', sans-serif" }}
          >
            השמירה על הסטנדרטים הגבוהים ביותר מבטיחה שכל ביס יעניק לאורחים חוויית טעמים עשירה, עוצמתית ונקייה.
          </p>
        </div>
      </section>

      {/* CTA */}
      <section className="py-16 bg-[#faf7f2]">
        <div className="max-w-3xl mx-auto px-6 text-center">
          <h2
            className="text-[#1a0a00] font-black text-3xl md:text-4xl mb-4"
            style={{ fontFamily: "'Assistant', sans-serif" }}
          >
            רוצים להביא את החוויה לאירוע שלכם?
          </h2>
          <p
            className="text-[#7a5c44] text-lg mb-8"
            style={{ fontFamily: "'Assistant', sans-serif" }}
          >
            צרו איתנו קשר ונבנה יחד את חוויית הבשרים המושלמת לאירוע שלכם
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Link
              to="/"
              className="bg-[#e85d04] hover:bg-[#d44d00] text-white px-8 py-4 rounded-full text-base font-bold transition-colors duration-200 cursor-pointer whitespace-nowrap"
              style={{ fontFamily: "'Assistant', sans-serif" }}
            >
              קבלו הצעת מחיר ←
            </Link>
            <Link
              to="/menu"
              className="border-2 border-[#1a0a00] text-[#1a0a00] hover:bg-[#1a0a00] hover:text-white px-8 py-4 rounded-full text-base font-semibold transition-all duration-200 cursor-pointer whitespace-nowrap"
              style={{ fontFamily: "'Assistant', sans-serif" }}
            >
              לתפריט המלא
            </Link>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default About;
